import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from '../../api/auth.service';
import { UserService } from '../../api/user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router'


@Component({
  selector: 'app-technician-details',
  templateUrl: './technician-details.component.html',
  styleUrls: ['./technician-details.component.scss']
})
export class TechnicianDetailsComponent implements OnInit {

  technicianName: any;
  technicianPhone: any;
  image: any;
  id: any;
  ispName: any;
  ispCity: any;

  constructor(
    private router: Router,
    private userService: UserService,
    private formBuilder: FormBuilder, 
    private modalService: NgbModal,
    private authService: AuthService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
    this.getTechnicianDetails();
    //this.getTechnicianImage();    
  }

  
  getTechnicianDetails() {
    this.userService.getTechnicianDetails(this.id).subscribe(res => {
      this.technicianName = res.data.technicianName;
      this.technicianPhone = res.data.phone_no;
      this.image = res.data.file;
      this.ispName = res.data.isp_name;
      this.ispCity = res.data.isp_city;
    });
  }

  // getTechnicianImage() {
  //   this.userService.getTechnicianImage(this.id).subscribe(res => {
  //     let objectURL = URL.createObjectURL(res);       
  //     this.image = this.sanitizer.bypassSecurityTrustUrl(objectURL);
  //   });
  // }

  

}
